import {
  Box,
  Card as BaseCard,
  CardProps as BaseCardProps,
  Group,
  Text,
  Title,
} from "@mantine/core";
import React from "react";

export interface CardProps extends BaseCardProps {
  title?: React.ReactNode;
  titleCount?: number | string;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

export const Card = ({
  title,
  titleCount,
  description,
  actions,
  children,
  className,
  ...props
}: CardProps) => {
  return (
    <BaseCard
      shadow="xs"
      radius="lg"
      withBorder
      style={{ transition: "all 200ms ease" }}
      {...props}
    >
      {(title || actions) && (
        <BaseCard.Section py="xs" px="lg" withBorder>
          <Group justify="space-between" mih={36} gap="xs">
            <Box>
              {title && (
                <Group gap={4}>
                  <Title order={4}>{title}</Title>
                  {titleCount !== undefined && (
                    <Title order={4} fw="normal">
                      ({titleCount})
                    </Title>
                  )}
                </Group>
              )}
              {description && (
                <Text fz="xs" opacity={0.6}>
                  {description}
                </Text>
              )}
            </Box>
            <Box mr={-10}>{actions}</Box>
          </Group>
        </BaseCard.Section>
      )}
      <BaseCard.Section p="lg" style={{ flexGrow: 1 }}>
        {children}
      </BaseCard.Section>
    </BaseCard>
  );
};
